export default {
  colorScheme: '配色方案',
  themeSettings: '主題設定',
};
